export const publicUrl = process.env.PUBLIC_URL;

export const blueArrowIcon = `${publicUrl}/assets/img/bluearrow.svg`;
export const footerLogo = `${publicUrl}/assets/img/footerlogo.svg`;
export const img = (name) => `${publicUrl}/assets/img/${name}`;
